<template>
  <div>
    <div v-if="erreurEnvoie">
      <p class="erreur-mail">Une erreur est survenue, veuillez réessayer, si l'erreur persiste merci de contacter le support.</p>
    </div>
    <div v-if="estMailEnvoye">
      <p>Le mail a été envoyé.</p>
    </div>
    <div v-else>
      <p>
        <span>Pour recevoir une synthèse de ces informations, renseignez votre e-mail dans le champ suivant.</span>
      </p>
      <div class="checkbox-wrapper" v-if="partageEmailAvailable">
        <input type="checkbox" v-model="partageEmail" id="partageEmail"/>
        <label for="partageEmail">Cocher cette case si vous souhaitez partager votre adresse mail avec l'université de Nantes afin d'être recontacté.</label>
      </div>
      <span class="erreur-mail" v-show="messageErreurAffiche">Merci de renseigner une adresse email valide.</span>
      <div class="recap-container">
        <input type="text" v-model="email"/>
        <button class="button-app button-primary" type="button" @click.prevent="envoyer">envoyer</button>
      </div>
    </div>
  </div>
</template>

<script>
import apiService from '../services/ApiService';

export default {
  name: 'envoyer-recapitulatif',
  data() {
    return {
      email: '',
      messageErreurAffiche: false,
      estMailEnvoye: false,
      erreurEnvoie: false,
      partageEmail: false
    };
  },
  computed: {
    /**
     * Permet de savoir s'il faut afficher la case à cocher permettant le partage d'email.
     */
    partageEmailAvailable: function () {
      let informationsParcours = this.$store.getters.getInformationsParcours;
      return informationsParcours.possedeExperienceProche || informationsParcours.possedeDiplomeProche
    }
  },
  methods: {
    /**
     * Permet de savoir si l'adresse email est valide.
     * @returns {boolean} Vrai si l'adresse email est valide, sinon faux.
     */
    estEmailValide() {
      return this.email.includes('@') && this.email.length > 2;
    },
    /**
     * Permet d'envoyer le mail récapitulatif à l'utilisateur.
     */
    envoyer() {
      this.messageErreurAffiche = !this.estEmailValide();
      if (!this.messageErreurAffiche) {
        let email = this.email;
        let partageEmail = this.partageEmail;
        this.$store.commit('setEmail', email);
        this.$store.commit('setPartageEmail', partageEmail);
        let informationsParcours = this.$store.getters.getInformationsParcours;
        apiService.sendMail(email, informationsParcours, this.retourEnvoi);
      }
    },
    /**
     * Callback de l'envoi de mail. Appelé une fois que la réponse à été reçue.
     * @param {Object} response La réponse du serveur.
     */
    retourEnvoi(response) {
      if (response.status === 202) {
        this.estMailEnvoye = true;
      } else {
        this.erreurEnvoie = true;
      }
    },
  }
}
</script>

<style scoped>
.recap-container {
  display: flex;
}

#appcompetences--widget input[type="text"] {
  border: 1px solid darkgrey;
  width: 100%;
}

#appcompetences--widget button {
  cursor: pointer;
}

.erreur-mail {
  font-weight: bold;
}
</style>
